export default "/_next/static/images/18/stairs-18bfeb81a3450ae945ba6f2b0c4cf7d6.jpg";